import * as React from 'react';
import OnboardTaskList from 'src/components/agency-onboard/task-list/task-list';
import {useLoadingApi} from 'src/hooks/useApi';

import TaskListHeader from 'src/components/agency-onboard/task-list-header/task-list-header';
import {Loading} from 'src/components/lib/loading/index';
import css from './task-container.css';
import maincss from 'src/components/agency-onboard/agency-onboard.css';


export default function OnboardTasksContainer() {
  const [tasks, setTasks] = React.useState<any>(null);
  const {response: tasksList, loaded} = useLoadingApi(
    () => 'onboard/tasks',
    [],
  );

  React.useEffect(() => {
    // @ts-expect-error - TS2339 - Property 'length' does not exist on type '{}'.
    if (tasksList && tasksList.length > 0) {
      const tasksDict = Object.assign(
        {},
        // @ts-expect-error - TS2339 - Property 'map' does not exist on type '{}'. | TS7006 - Parameter 'each' implicitly has an 'any' type.
        ...tasksList.map((each) => ({[each.id]: each})),
      );
      setTasks(tasksDict);
    }
  }, [tasksList]);

  if (!loaded || !tasksList) {
    return (
      <div>
        <Loading className={maincss.loaderDiv} />
      </div>
    );
  }

  if (tasks) {
    return (
      <div className={css.onboardTasksContainer}>
        <div className={css.taskSection}>
          <TaskListHeader tasks={tasks} />
          {/* @ts-expect-error - TS2322 - Type 'Dispatch<any>' is not assignable to type '() => unknown'. */}
          <OnboardTaskList tasks={tasks} setTasks={setTasks} />
        </div>
      </div>
    );
  }

  return <></>;
}
